import { render, staticRenderFns } from "./o-x3-column-text.vue?vue&type=template&id=4d4b6233&scoped=true"
import script from "./o-x3-column-text.vue?vue&type=script&lang=js"
export * from "./o-x3-column-text.vue?vue&type=script&lang=js"
import style0 from "./o-x3-column-text.vue?vue&type=style&index=0&id=4d4b6233&prod&lang=scss"
import style1 from "./o-x3-column-text.vue?vue&type=style&index=1&id=4d4b6233&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4b6233",
  null
  
)

export default component.exports